import React from 'react';
import { PANTHER_CONFIG } from 'Source/constants';
import { SplitFactory } from '@splitsoftware/splitio-react';
import { datadogRum } from '@datadog/browser-rum';
import { AppConfigContext, AppConfigContextType } from '../AppBootstrapper/AppConfigContext';

const SplitProvider = ({ children }: { children: React.ReactElement }) => {
  const appConfig = React.useContext<AppConfigContextType>(AppConfigContext)?.[0];
  if (!appConfig) {
    return <>{children}</>;
  }

  return (
    <SplitFactory
      config={{
        core: {
          authorizationKey: appConfig.splitClientToken,
          key: `${appConfig.accountId}_${PANTHER_CONFIG.AWS_REGION}`,
        },
        impressionListener: {
          logImpression(impressionData) {
            datadogRum.addFeatureFlagEvaluation(
              impressionData.impression.feature,
              impressionData.impression.treatment,
            );
          },
        },
        storage: {
          type: 'LOCALSTORAGE',
        },
      }}
    >
      {children}
    </SplitFactory>
  );
};

export default React.memo(SplitProvider);
